import type { IconName } from "@/components/icons/icon-names"
import { DetailedEventActor, EventActor } from "./event-actor"
import { DetailedInspiration, Inspiration } from "./inspiration"
import { DetailedPlace, Place } from "./place"

export type Entity = Place | Inspiration | EventActor
export type DetailedEntity =
  | DetailedPlace
  | DetailedInspiration
  | DetailedEventActor

export type PlaceRefPrefix = "ac" | "ap" | "at" | "ev" | "ho" | "lo" | "re"
export type InspirationRefPrefix = "in"
export type EventRefPrefix = "ev"
export type EventActorRefPrefix = "ea"
export type AirlineRefPrefix = "al"

export type PlaceRef = `${PlaceRefPrefix}-${string}`
export type InspirationRef = `${InspirationRefPrefix}-${string}`
export type EventRef = `${EventRefPrefix}-${string}`
export type EventActorRef = `${EventActorRefPrefix}-${string}`
export type AirlineRef = `${AirlineRefPrefix}-${string}`

export type EntityRef = PlaceRef | InspirationRef | EventActorRef | AirlineRef

export interface ShareableUrl {
  name: string
  icon: IconName
  url: string
}

// regex that matches entity ref prefixes
const PlaceRefRE = /^(ac|ap|at|ev|ho|lo|re)-[a-zA-Z0-9]{8}$/
const InspirationRefRE = /^in-[a-zA-Z0-9]{8}$/
const EventRefRE = /^ev-[a-zA-Z0-9]{8}$/
const EventActorRefRE = /^ea-[a-zA-Z0-9]{8}$/

export function isEntityRef(value: string): value is EntityRef {
  return isPlaceRef(value) || isInspirationRef(value) || isEventActorRef(value)
}

export function isInspirationRef(value: string): value is InspirationRef {
  return InspirationRefRE.test(value)
}

export function isPlaceRef(value: string): value is PlaceRef {
  return PlaceRefRE.test(value)
}

export function isEventActorRef(value: string): value is EventActorRef {
  return EventActorRefRE.test(value)
}

export function isEventRef(value: string): value is EventRef {
  return EventRefRE.test(value)
}
